module.exports = __webpack_public_path__ + "static/media/catering.46fea6df.png";